@import "./helpers/scss-helper";

:host {
  display: block;
  @include eon-typography();
  text-align: left;
}

.#{$prefix}content-aggregator-item__list {
  text-decoration: none;
  outline-style: none;

  &:hover {
    outline-style: none;

    @if (variable-exists(content-aggregator-item-list-view-bright-box-shadow-content-hover)) {
      .#{$prefix}content-aggregator-item__list--wrapper {
        &.#{$prefix}ultralightgrey {
          box-shadow: $content-aggregator-item-list-view-bright-box-shadow-content-hover;
        }
        @if (variable-exists(content-aggregator-item-list-view-box-shadow-content-hover)) {
          box-shadow: $content-aggregator-item-list-view-box-shadow-content-hover;
        }
        margin-bottom: -2px;
        border-bottom: 2px solid v(hoverColor);
      }
    }
  }

  &--wrapper {
    cursor: pointer;
    display: grid;
    font-family: $font-family-base;
    grid-template-columns: repeat(12, [col-start] 1fr);
    overflow: hidden;
    background-color: v(backgroundColor);

    @include for-size(phone) {
      grid-template-columns: 100%;
      grid-template-areas: "date" "content" "button";
      position: relative;
    }
    @include borderRadius("list_view", "content");
    @include boxShadow("list_view", "content");
  }

  &--content {
    font-family: $font-family-base;
    grid-column: 2 col-start / -2;
    padding: 24px 28px 32px 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: v(contentColor);

    &.#{$prefix}size-h5 {
      padding: 27px 28px 27px 48px;

      @include for-size(desktop) {
        padding: 25px 32px;
      }
      @include for-size(tablet) {
        padding: 24px 24px 24px 32px;
      }

      .#{$prefix}content-aggregator-item__list--headline {
        margin-bottom: 4px;

        eon-ui-headline {
          color: v(linkColor);
        }
      }

      .#{$prefix}content-aggregator-item__list--body {
        eon-ui-text {
          color: v(contentColor);
        }
      }

      @include for-size(phone) {
        padding: 0px 16px 24px 16px;
        grid-area: 3;
      }
    }

    &.#{$prefix}size-copy {
      padding: 33px 28px 33px 48px;

      @include for-size(desktop) {
        padding: 24px 32px;
      }

      @include for-size(tablet) {
        padding: 24px 24px 24px 32px;
      }

      .#{$prefix}content-aggregator-item__list--headline {
        margin-bottom: 2px;
        eon-ui-headline {
          color: v(linkColor);
        }
      }

      @include for-size(phone) {
        padding: 0px 16px 24px 16px;
        grid-area: 3;
      }
    }
  }

  &--date {
    font-family: $font-family-base;
    grid-column: col-start / span 1;
    eon-ui-date-event {
      --dateColor: var(--contentColor);
      --borderLeft: 1px solid var(--leftBorderColor);
    }

    &.#{$prefix}hide-time {
      padding: 24px 0 24px 40px;
      @include for-size(phone) {
        padding: 12px 0 16px 16px;
        height: 36px;
        justify-content: center;
      }

      @include for-size(tablet) {
        min-width: 88px;
      }

      @include for-size(desktop-or-larger) {
        min-width: 90px;
      }
    }

    &.#{$prefix}show-time {
      padding: 24px 0 24px 32px;

      @include for-size(desktop) {
        padding: 24px 0 24px 32px;
      }

      @include for-size(tablet) {
        padding: 24px 0 24px 32px;
      }

      @include for-size(phone) {
        padding: 12px 0 16px 16px;
        height: 50px;
        justify-content: center;
      }

      @include for-size(tablet-or-larger) {
        min-width: 160px;
      }
    }

    &.#{$prefix}size-h5 {
      @include for-size(desktop-l-or-larger) {
        padding: 27px 0 27px 32px;
      }

      @include for-size(desktop) {
        padding: 25px 0 25px 32px;
      }
    }

    &.#{$prefix}size-copy {
      @include for-size(desktop-l-or-larger) {
        padding: 33px 0 33px 32px;
      }

      @include for-size(desktop) {
        padding: 24px 0 24px 32px;
      }
    }

    &.#{$prefix}copy {
      padding: 24px 32px;
    }

    &.#{$prefix}list-category {
      padding: 24px 0 24px 32px;

      @include for-size(phone) {
        padding: 20px 0 16px 16px;
      }

      @include for-size(tablet) {
        min-width: 88px;
      }

      @include for-size(desktop-or-larger) {
        min-width: 90px;
      }
    }

    &.#{$prefix}hour-format {
      @include for-size(tablet-or-larger) {
        min-width: 130px;
      }
    }

    @include for-size(phone) {
      display: flex;
      flex-direction: column;
      column-gap: 8px;
      position: absolute;
    }
  }
  &--category {
    color: v(contentColor);
    text-align: right;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  &--button {
    font-family: $font-family-base;
    padding-right: 24px;
    grid-column: 12 col-start / -1;
    display: flex;
    justify-content: center;
    align-items: center;

    @include for-size(phone) {
      grid-area: 1;
      display: flex;
      flex-direction: row;
      column-gap: 8px;
      justify-content: flex-end;
      align-items: flex-end;
      &.#{$prefix}show-time {
        padding: 13px 0 15px 0;
      }

      &.#{$prefix}hide-time {
        padding: 8px 0;
      }
    }
  }
}

:host([inner-background="eon-ultralightgrey"]) {
  eon-ui-button {
    --primaryBackgroundColor: var(--eon-ultralightgrey);
    --primaryBackgroundHoverColor: var(--eon-white);
    --primaryBackgroundFocusColor: var(--eon-ultralightgrey);
    --primaryTextAndIconColor: var(--eon-middlegrey);
    --primaryTextAndIconHoverColor: var(--eon-middlegrey-active);
    --primaryBorderColor: var(--eon-ultralightgrey);
    --primaryBorderHoverColor: var(--eon-white);
  }
}
